import { Modal, Row, Col } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "../../../assets/css/commonVessels.css";

const ErrorModal = (props) => {
    return (
        <>
            <Modal
                width={700}
                className="errorMessageModal"
                open={props.showError}
                footer={null}
                closable={false}
                centered
            >
                <Row>
                    <Col xs={3} md={2} lg={2} xl={2}>
                        <ExclamationCircleOutlined className="exclamatoryIcon" />
                    </Col>
                    <Col xs={18} md={20} lg={20} xl={20} className="errorMessageModal">
                        <p className="errorModalTitle">{props.errorMessage}</p>
                        <p className="errorModalDescription">{props.errorDescription}</p>
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default ErrorModal;
